'use client'

import { useState } from 'react'
import { DateSelection } from '@repo/ui/DateSelection'
import { SaveIcon } from '@repo/ui/SaveIcon'
import { useMattersStore } from '@repo/store/useMattersStore'
import MUIButton from '@mui/material/Button'
import MUIInput from '@mui/material/TextField'
import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'

export const NotesForm = ({
  entityId,
  matterNoteId,
  matterNotes = '',
  dateEntered,
  onSubmitComplete = () => {},
  onCancel = () => {}
}) => {
  const { createMatterNotes, updateMatterNotes } = useMattersStore()
  const mode = matterNoteId ? 'edit' : 'create'
  const [notes, setNotes] = useState(mode === 'edit' ? matterNotes : '')
  const [date, setDate] = useState(mode === 'edit' ? dateEntered : new Date())

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!notes || !date) return

    if (mode === 'edit') {
      await updateMatterNotes({ clientMatterNo: entityId, matterNoteId, dateEntered: date, notes })
    } else {
      await createMatterNotes({ clientMatterNo: entityId, dateEntered: date, notes })
    }

    onSubmitComplete()
  }

  return (
    <>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <MUIStack
          data-testid="NotesForm"
          direction="column"
          gap={2}
          sx={{ mb: '20px', width: '100%', backgroundColor: '#DFD1B655', padding: '20px', borderRadius: '6px' }}
          alignItems="flex-end"
        >
          {mode === 'create' ? (
            <DateSelection
              required
              value={date}
              onChange={setDate}
              sx={{ width: '100%', mb: 2 }}
              label="Date"
              enableTypedDdMmYyyy={true}
              showAdornment={true}
            />
          ) : null}

          <MUIInput
            label="Note"
            multiline
            rows={6}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            required
            sx={{
              width: '100%',
              m: 0,
              'input, textarea, .MuiInputBase-multiline, .MuiInputBase-root': { backgroundColor: 'white' },
              '&.MuiTextField-root': { backgroundColor: 'transparent !important' }
            }}
          />
          <MUIStack direction="row" gap={2}>
            <MUIButton
              variant="text"
              color="primary"
              onClick={onCancel}
              sx={{
                width: '80px',
                m: 0
              }}
            >
              Cancel
            </MUIButton>
            <MUIButton
              variant="contained"
              sx={{
                width: '100px',
                m: 0,
                backgroundColor: 'success.light',
                '&:hover': { backgroundColor: 'success.lightHover' }
              }}
              type="submit"
            >
              <SaveIcon sx={{ color: 'white', width: '18px', marginRight: '10px' }} />
              Save
            </MUIButton>
          </MUIStack>
        </MUIStack>
      </form>
    </>
  )
}

NotesForm.propTypes = {
  entityId: PropTypes.string,
  matterNoteId: PropTypes.number,
  matterNotes: PropTypes.string,
  dateEntered: PropTypes.any,
  onSubmitComplete: PropTypes.func,
  onCancel: PropTypes.func
}
